var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCerebralzipLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 160,
    viewBox: "0 0 152 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.751 43.5245C144.976 40.9869 146.07 35.2964 143.072 31.3689C128.147 11.8212 104.723 0 79.9613 0C58.1807 0 37.85 8.69099 22.7325 24.4985C7.61371 40.2913 -0.256003 61.0898 0.557279 83.0654C2.07089 124.008 35.0779 157.747 75.7022 159.885C77.1134 159.961 78.5247 160 79.9347 160C107.996 160 133.934 145.241 148.341 120.796C152.447 113.847 152.511 105.489 148.519 98.4368C144.475 91.2949 137.202 87.033 129.065 87.033C121.322 87.033 113.998 91.1932 109.968 97.9004C103.674 108.342 92.6881 114.564 80.5845 114.564C76.5155 114.564 72.5739 113.86 68.8863 112.515C63.8644 110.712 59.3129 107.716 55.5229 103.658C48.9755 96.6202 45.6944 87.4303 46.3057 77.7534C47.3728 60.6283 61.5495 46.4608 78.5752 45.4883C80.4702 45.3732 82.3519 45.424 84.1951 45.6407C92.5711 46.5263 100.305 50.4765 105.956 56.7115C108.576 59.6022 112.908 60.1293 116.227 58.0907C120.599 55.4019 121.557 49.3328 118.102 45.523C107.895 34.269 93.1067 28.0635 77.6344 28.9397C57.5322 30.0794 40.5583 42.9788 33.3995 60.936L33.349 61.039C31.4155 65.9269 30.2088 71.188 29.866 76.6792V76.7181C28.9743 91.002 33.8314 104.594 43.5337 114.999C53.095 125.251 66.5979 131.138 80.5845 131.138C98.486 131.138 114.736 121.923 124.043 106.488C125.124 104.683 127.005 103.595 129.065 103.595C132.155 103.595 133.692 105.719 134.215 106.628C134.697 107.5 135.688 109.802 134.188 112.337C122.186 132.699 100.087 144.59 76.5659 143.337C44.3735 141.646 18.2063 114.897 16.997 82.4514C16.3618 65.0065 22.6049 48.5221 34.5822 35.9906C46.5715 23.4605 62.695 16.562 79.9613 16.562C99.6329 16.562 118.255 25.9874 130.084 41.5568C132.591 44.8555 137.207 45.6555 140.751 43.5245Z",
    fill: "url(#paint0_linear_2533_833)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.424 78.9822C100.424 90.4716 91.1706 99.7847 79.7581 99.7847C68.3455 99.7847 59.0938 90.4716 59.0938 78.9822C59.0938 67.4941 68.3455 58.1797 79.7581 58.1797C91.1706 58.1797 100.424 67.4941 100.424 78.9822Z",
    fill: "url(#paint1_linear_2533_833)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2533_833",
    x1: 75.9993,
    y1: 160,
    x2: 53.2654,
    y2: 3.29835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#375DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2533_833",
    x1: 79.9718,
    y1: 99.9982,
    x2: 73.5781,
    y2: 59.6788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375DFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerebralzipLogo);
export default __webpack_public_path__ + "static/media/cerebralzip-logo.b8f03948926e5d7b15af8c29c201a99f.svg";
export { ForwardRef as ReactComponent };